import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import './index.scss';

const MutateMarketplaceSelect = ({ name, options, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <>
      <select
        {...props}
        {...field}
        className={classNames(
          'mutate-action-value',
          { 'mutate-value-error': fieldMeta.error },
          // eslint-disable-next-line react/destructuring-assignment
          props.className,
        )}
      >
        <option value="">None</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};
export default MutateMarketplaceSelect;
